import { Button, Card, Divider, Flex, Form, Image, Input, Space, theme } from "antd";
import { useForm, useWatch } from "antd/es/form/Form";
import { EyeTwoTone, EyeInvisibleOutlined, GoogleOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import AuthService from "services/auth";
import { useAuth } from "contexts/auth";
import { useApp } from "contexts/app";
import { useEffect, useState } from "react";


const authService = new AuthService();

function Login() {
    const { token } = theme.useToken();
    const [form] = useForm();

    const { loading, showLoading } = useApp();
    const [loginError, setLoginError] = useState(null);
    const navigate = useNavigate();
    const { login } = useAuth();

    const email = useWatch("email", { form });

    useEffect(() => {
        localStorage.removeItem('workSpace');

    }, []);

    const handleContinue = () => {
        form.submit();
    };

    const onFinish = async () => {

        setLoginError(null);
        showLoading(true);
        const data = { ...form.getFieldsValue() };
        const user = await authService.userLogin(data);
        showLoading(false)
        if (user) {
            login(user);
        } else {
            setLoginError({ message: "Incorrect username or password" });
        }

    };




    return (
        <Card style={{ width: "500px", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
            <Flex vertical gap={14}>
                <Space direction="vertical" align="center">
                    <img width={200} style={{ borderRadius: "8px" }} src="https://down-bs-vn.img.susercontent.com/vn-11134233-7ras8-m5xh3hvm3kc8b5_tn.webp" />
                    <span style={{ fontSize: token.fontSizeHeading3, fontWeight: "500" }}>Welcome back!</span>
                    <span>Log in to your account</span>
                </Space>
                <Form layout="vertical" form={form} initialValues={{}} onFinish={onFinish}>
                    <Form.Item
                        label="Email hoặc số điện thoại"
                        name="email"
                        validateTrigger="onBlur"
                        rules={[

                            {
                                required: true,
                                message: `Bạn phải nhập email hoặc số điện thoại`,
                            },
                        ]}
                    >
                        <Input placeholder="Email"></Input>
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="pass"
                        rules={[
                            {
                                required: true,
                                message: `Password is required`,
                            },
                        ]}
                    >
                        <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                    </Form.Item>

                    <Space direction="vertical" style={{ width: "100%" }} size={"large"}>
                        {loginError && (
                            <div style={{ float: "right" }}>
                                <span style={{ color: token.colorErrorText }}>{loginError.message}</span>
                            </div>
                        )}

                        <div style={{ float: "right" }}>
                            <Button size="small" type="link" onClick={() => navigate("/reset-password")}>
                                Forgot password?
                            </Button>
                        </div>

                        <Button type="primary" style={{ width: "100%" }} onClick={() => handleContinue()}>
                            Đăng nhập
                        </Button>

                        {/* <Divider orientation="center" style={{ opacity: "0.5" }}>
                            OR
                        </Divider>



                        <Button type="primary" style={{ width: "100%" }} onClick={null} ghost>
                            <img width="26" height="26" src="https://img.icons8.com/color/48/google-logo.png" alt="google-logo" />  Continue With Google
                        </Button>

                        <Button type="primary" style={{ width: "100%" }} onClick={e=>navigate("/workspacelogin")} ghost>
                            Continue With Workspace Account
                        </Button>

                        {/* <GoogleLogin
                            onSuccess={credentialResponse => {
                                console.log("login ok " , credentialResponse);
                            }}
                            onError={() => {
                                console.log('Login Failed');
                            }}
                            style={{width:"100%"}}
                          
                        /> */}


                        <Divider orientation="center" style={{ opacity: "0.5" }}>
                            Hoặc
                        </Divider>

                        <Button type="primary" style={{ width: "100%" }} onClick={() => navigate("/register")}>
                            Đăng ký
                        </Button>

                    </Space>
                </Form>
            </Flex>
        </Card>
    );
}

export default Login;
